/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { useEffect, useState } from 'react'
import {
  Container,
  Navbar,
  Nav,
  Dropdown,
  ListGroup,
  Tab,
  Button,
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, NavLink } from 'react-router-dom'
import Mycart from '../assets/images/cart.svg'
import DownArrow from '../assets/images/arrowdown.svg'
import Notification from '../assets/images/notification.svg'
import ProfileIcon from '../assets/images/profile.svg'
import Paymentdetail from '../assets/images/paymentdetail.svg'
import Password from '../assets/images/password.svg'
import Logout from '../assets/images/logout.svg'
import Help from '../assets/images/help.svg'
import Purchase from '../assets/images/purchase.svg'
import { dispatch } from '../redux'
import { getOrganization, logout, userDetailsGet } from '../redux/action'
import HeaderLogo from '../assets/images/headerLogo.svg'
import ResumeLibraryIcon from '../assets/images/ResumeLibraryIcon.svg'
import RecruitmentAgencyIcon from '../assets/images/recruitment_agency_icon.svg'
import ExamCount from '../assets/images/exam.svg'
import DefaultUser from '../assets/images/defaultUser.png'
import { useSelector } from 'react-redux'
import { Store } from '../redux/Actions'
import {
  headerTabAccess,
  moreTabAccess,
  ShowContent,
  userRole,
} from '../util/userBasedAuth'
import { getDecryptRole } from '../util/crypto'
import Noimage from '../assets/images/noImage.svg'
import { MdOutlineBusinessCenter } from 'react-icons/md'
import { FormattedMessage } from 'react-intl'
export interface UserDetailInit {
  response: Object
}
export default function Header() {
  const userType = getDecryptRole() || ''

  const { pathname } = useLocation()

  const initialState: UserDetailInit = { response: {} }
  const [userDetailsLoc, setUserDetailsLoc] = useState<any>(initialState)
  const [userDetails, setUserDetails] = useState<any>(initialState)

  const userDetailLoc = useSelector(
    (state: Store) => state.userDataReducer.user
  ) as UserDetailInit

  const userDetail = useSelector(
    (state: Store) => state.userDataReducer.userDetailsData
  ) as any

  const profileData = useSelector(
    (state: Store) => state?.organisationDataReducer?.organizationProfile
  ) as any

  const userInstituteId = useSelector(
    (state: Store) =>
      state?.userDataReducer?.userDetailsData?.data?.institute?.id
  )

  const handleLogout = () => {
    dispatch(logout())
  }
  const navigate = useNavigate()

  const notification = () => {
    navigate('/notification')
  }
  useEffect(() => {
    setUserDetailsLoc(userDetailLoc?.response)
  }, [userDetailLoc])

  useEffect(() => {
    if (userDetailsLoc?.data?.user?.id && pathname !== '/my-profile') {
      dispatch(userDetailsGet(false, userDetailsLoc?.data?.user?.id))
    }
  }, [userDetailsLoc?.data?.user?.id])

  useEffect(() => {
    setUserDetails(userDetail)
  }, [userDetail])

  useEffect(() => {
    userInstituteId && dispatch(getOrganization(userInstituteId))
  }, [userInstituteId])

  return (
    <Navbar bg="white" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/home" style={{ width: '8rem' }}>
          {profileData?.logo ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${profileData?.logo}`}
              alt="NoProfile"
              style={{ width: '100%', height: '50px' }}
            />
          ) : (
            <img
              src={Noimage}
              alt="Noimage"
              style={{ width: '100%', height: '50px' }}
            />
          )}
        </Navbar.Brand>
        <div className="verticle-line" />
        <Navbar.Brand as={Link} to="/home">
          <img src={HeaderLogo} alt="top logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav justify-content-end">
          <Nav className="ms-auto">
            <ShowContent
              contentHasAccess={headerTabAccess.home}
              role={userType}
            >
              <NavLink
                to="/home"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <FormattedMessage id="Home" defaultMessage="Home" />
              </NavLink>
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.batch}
              role={userType}
            >
              <NavLink
                to="/batches"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <FormattedMessage id="Batch" defaultMessage="Batch" />
              </NavLink>
            </ShowContent>
            {/* <ShowContent
              contentHasAccess={moreTabAccess.jobRole}
              role={userType}
            >
              <NavLink
                to="/job-role"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <FormattedMessage id="Job_Role" defaultMessage="Job Role" />
              </NavLink>
            </ShowContent> */}
            <ShowContent
              contentHasAccess={headerTabAccess.exam}
              role={userType}
            >
              {userType !== userRole.SUBJECT_MATTER_EXPERT ? (
                <NavLink
                  to="/exams"
                  className={`nav-link ${({ isActive }: never) =>
                    isActive ? 'active' : ''}`}
                >
                  <FormattedMessage id="Exam" defaultMessage="Exam" />
                </NavLink>
              ) : (
                <Dropdown>
                  <Dropdown.Toggle
                    as={Link}
                    id="dropdown-basic"
                    className="ms-3"
                    to="#"
                  >
                    <FormattedMessage id="Exam" defaultMessage="Exam" />
                    <i className="fas fa-chevron-down fa-sm ms-2"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="my-profile-dropdown">
                    <Dropdown.Item as={Link} to="/requested-exam">
                      <FormattedMessage
                        id="Requested_Exams"
                        defaultMessage="Requested Exams"
                      />
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/exams">
                      <FormattedMessage
                        id="Assigned_Exams"
                        defaultMessage="Assigned Exams"
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.organisation}
              role={userType}
            >
              <NavLink
                to="/organisation"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <FormattedMessage
                  id="Organisation"
                  defaultMessage="Organisation"
                />
              </NavLink>
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.Questionnaire}
              role={userType}
            >
              <Dropdown>
                <Dropdown.Toggle
                  as={Link}
                  id="dropdown-basic"
                  className="ms-3"
                  to="#"
                >
                  <FormattedMessage id="Questions" defaultMessage="Questions" />
                  <i className="fas fa-chevron-down fa-sm ms-2"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-profile-dropdown">
                  <Dropdown.Item as={Link} to="/create-new-question">
                    <FormattedMessage
                      id="Add_Question"
                      defaultMessage="Add Question"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/questions/bulk-upload">
                    <FormattedMessage
                      id="Upload_Questions"
                      defaultMessage="Upload Questions"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/questions/upload-question-paper"
                  >
                    <FormattedMessage
                      id="Upload_Question_Paper"
                      defaultMessage="Upload Question Paper"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/questions/upload-history">
                    <FormattedMessage
                      id="Upload_History"
                      defaultMessage="Upload History"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/questionnaire">
                    <FormattedMessage
                      id="Questions_Library"
                      defaultMessage="Questions Library"
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ShowContent>
            <ShowContent
              contentHasAccess={moreTabAccess.jobRole}
              role={userType}
            >
              <Dropdown>
                <Dropdown.Toggle
                  as={Link}
                  id="dropdown-basic"
                  className="ms-5 me-3"
                  to="#"
                >
                  <FormattedMessage id="More" defaultMessage="More" />
                  <i className="fas fa-chevron-down fa-sm ms-2"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-profile-dropdown">
                  <Dropdown.Item
                    as={Link}
                    to="/job-role-list"
                    className="d-flex align-items-center"
                  >
                    <MdOutlineBusinessCenter size={24} className="me-2" />{' '}
                    <FormattedMessage id="Job_Role" defaultMessage="Job Role" />
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/resume-library"
                    className="d-flex align-items-center"
                  >
                    <img src={ResumeLibraryIcon} alt="resume library logo" />{' '}
                    <FormattedMessage
                      id="Resume_Library"
                      defaultMessage="Resume Library"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/recruitment-agencies">
                    <img
                      src={RecruitmentAgencyIcon}
                      alt="recruitment agency logo"
                    />{' '}
                    <FormattedMessage
                      id="Recruitment_Agencies"
                      defaultMessage="Recruitment Agencies"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/batchwise-exam-details">
                    <img src={ExamCount} alt="Exam usage logo" />{' '}
                    <FormattedMessage
                      id="Exam_details"
                      defaultMessage="Exam Details"
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.store}
              role={userType}
            >
              <NavLink
                to="/market-place"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <FormattedMessage id="Store" defaultMessage="Store" />
              </NavLink>
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.invitations}
              role={userType}
            >
              <NavLink
                to="/invitations"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <FormattedMessage
                  id="Invitations"
                  defaultMessage="Invitations"
                />
              </NavLink>
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.cart}
              role={userType}
            >
              <NavLink
                to="/"
                className={`nav-link ${({ isActive }: never) =>
                  isActive ? 'active' : ''}`}
              >
                <img src={Mycart} alt="Cart Image" />
              </NavLink>
            </ShowContent>
            <ShowContent
              contentHasAccess={headerTabAccess.notification}
              role={userType}
            >
              <Dropdown>
                <Dropdown.Toggle
                  as={Link}
                  id="dropdown-basic"
                  className="notify"
                  to="#"
                >
                  <Nav.Link href="#">
                    <img src={Notification} alt="notification Image" />
                  </Nav.Link>
                </Dropdown.Toggle>
                <div className="drop-down top-notification">
                  <Dropdown.Menu>
                    <div className="mx-auto">
                      <div className="d-flex px-3 my-3">
                        <p className="fw-semibold m-0">
                          <FormattedMessage
                            id="Notification"
                            defaultMessage="Notification"
                          />
                        </p>
                        <Link
                          to=""
                          className="ms-auto fw-semibold font-size-14"
                        >
                          <FormattedMessage
                            id="Mark_All_As_Read"
                            defaultMessage="Mark all as read"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="tab-light-border">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="first"
                      >
                        <div className="position-relative border-bottom">
                          <Nav variant="pills" className="d-flex flex-row">
                            <Nav.Item>
                              <Nav.Link eventKey="first">
                                <FormattedMessage
                                  id="All"
                                  defaultMessage="All"
                                />
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="second">
                                <FormattedMessage
                                  id="Unread"
                                  defaultMessage="Unread"
                                />
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="third">
                                <FormattedMessage
                                  id="All_Notifications"
                                  defaultMessage="All notifications"
                                />
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </div>
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <ListGroup
                              variant="flush"
                              className="pointer font-size-14"
                            >
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      <FormattedMessage
                                        id="Approval_Request"
                                        defaultMessage="Approval Request"
                                      />
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    HR <Link to="">@Robert R</Link> Requested to
                                    purchase questionnaire for Dec 2022 Batch.
                                  </p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      Report Avaliable
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    Sep 2022 Batch of Adyar branch is avaliable.
                                  </p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      Report Avaliable
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    Sep 2022 Batch of Adyar branch is avaliable.
                                  </p>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <ListGroup
                              variant="flush"
                              className="pointer font-size-14"
                            >
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      <FormattedMessage
                                        id="Approval_Request"
                                        defaultMessage="Approval Request"
                                      />
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    HR <Link to="">@Robert R</Link> Requested to
                                    purchase questionnaire for Dec 2022 Batch.
                                  </p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      Report Avaliable
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    Sep 2022 Batch of Adyar branch is avaliable.
                                  </p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      Report Avaliable
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    Sep 2022 Batch of Adyar branch is avaliable.
                                  </p>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Tab.Pane>
                          <Tab.Pane eventKey="third">
                            <ListGroup
                              variant="flush"
                              className="pointer font-size-14"
                            >
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      <FormattedMessage
                                        id="Approval_Request"
                                        defaultMessage="Approval Request"
                                      />
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    HR <Link to="">@Robert R</Link> Requested to
                                    purchase questionnaire for Dec 2022 Batch.
                                  </p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      Report Avaliable
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    Sep 2022 Batch of Adyar branch is avaliable.
                                  </p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={notification}>
                                <div className="my-2">
                                  <div className="d-flex align-items-center">
                                    <h4 className="mb-0 font-size-14">
                                      Report Avaliable
                                    </h4>
                                    <p className="mb-0 font-size-12 ms-auto">
                                      06:25pm
                                    </p>
                                  </div>
                                  <p className="mb-0 mt-3 text">
                                    Sep 2022 Batch of Adyar branch is avaliable.
                                  </p>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                      <div className="text-center see-all">
                        <Link
                          to="/notification"
                          className="fw-semibold font-size-14"
                        >
                          <FormattedMessage
                            id="See_All"
                            defaultMessage="See all"
                          />
                        </Link>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </div>
              </Dropdown>
            </ShowContent>
            <Dropdown className="profile-btn">
              <Dropdown.Toggle
                as={Button}
                variant="link"
                id="dropdown-basic"
                className="ms-3 blank-btn"
              >
                <img
                  src={
                    userDetails?.data?.photo
                      ? `${process.env.REACT_APP_IMAGE_URL}${userDetails?.data?.photo}`
                      : DefaultUser
                  }
                  className="header-user-phot"
                  alt={userDetails?.data?.first_name}
                />
                <img src={DownArrow} className="ms-2" alt="Down Arrow" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="my-profile-dropdown">
                <ShowContent
                  contentHasAccess={headerTabAccess.settings.myProfile}
                  role={userType}
                >
                  <Dropdown.Item
                    as={Link}
                    to="/my-profile"
                    state={{ active: 'first' }}
                  >
                    <img src={ProfileIcon} alt="Profile Image" />
                    <FormattedMessage
                      id="My_Profile"
                      defaultMessage="My profile"
                    />
                  </Dropdown.Item>
                </ShowContent>
                <ShowContent
                  contentHasAccess={headerTabAccess.settings.paymentDetails}
                  role={userType}
                >
                  <Dropdown.Item as={Link} to="#">
                    <img src={Paymentdetail} alt="Questionnaire Image" />
                    <FormattedMessage
                      id="Payment_Details"
                      defaultMessage="Payment details"
                    />
                  </Dropdown.Item>
                </ShowContent>
                <ShowContent
                  contentHasAccess={headerTabAccess.settings.purchaseHistory}
                  role={userType}
                >
                  <Dropdown.Item as={Link} to="/purchase-history">
                    <img src={Purchase} alt="Questionnaire Image" />
                    <FormattedMessage
                      id="Purchase_History"
                      defaultMessage="Purchase history"
                    />
                  </Dropdown.Item>
                </ShowContent>
                <ShowContent
                  contentHasAccess={headerTabAccess.settings.changePassword}
                  role={userType}
                >
                  <Dropdown.Item
                    as={Link}
                    to="/my-profile"
                    state={{ active: 'second' }}
                  >
                    <img src={Password} alt="Questionnaire Image" />
                    <FormattedMessage
                      id="Change_Password"
                      defaultMessage="Change password"
                    />
                  </Dropdown.Item>
                </ShowContent>
                <ShowContent
                  contentHasAccess={headerTabAccess.settings.help}
                  role={userType}
                >
                  <Dropdown.Item as={Link} to="#">
                    <img src={Help} alt="Questionnaire Image" />
                    <FormattedMessage id="Help" defaultMessage="Help" />
                  </Dropdown.Item>
                </ShowContent>
                <Dropdown.Item onClick={handleLogout}>
                  <img src={Logout} alt="Questionnaire Image" />
                  <FormattedMessage id="Logout" defaultMessage="Logout" />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
